import React, { useState, useEffect, useRef, useContext } from "react";
import DynamicIcon from "../../components/dynamicicon";
import { Link, useNavigate, useParams } from "react-router-dom";
import * as Constants from "../../constants";
import { ShareContext } from "../../context/ShareContext";
import BackLoader from "../../components/backloader";
import JisButton from "../../components/controls/jisButton";
import JisEmptyList from "../../components/controls/emptylist";
import CaseDetails from "../../components/core/caseDetails";
import JisYesNo from "../../components/controls/jisYesNo";
import JisCheckbox from "../../components/controls/jisCheckbox";
import moment from "moment";
import JisTabButton from "../../components/controls/jisTabButton";
import JisDialogForm from "../../components/formdialog";
import JisPrompt from "../../components/jisprompt";
import ViewDocuments from "../../components/core/case_views/documents";
import ViewComments from "../../components/core/case_views/comments";
import MultiSelectDropdown from "../../components/controls/multiselectdropdown";
import PdfViewer from "../../components/controls/pdfviewer";
import ViewJudgement from "../../components/core/case_views/judgement";
import JisVoiceRecorder from "../../components/jisVoicerecorder";

function Hearing() {
  const navigate = useNavigate();
  const { scheduleid } = useParams();
  const { activePage, token, profile, frequentData, setIsExpired, setAlert } =
    useContext(ShareContext);
  const [cinfo, setCaseInfo] = useState({});
  const [hearingId, setHearingId] = useState(0);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");
  const [tab, setTab] = useState("caseinfo");
  const [judgenote, setJudgeNote] = useState("");
  const [selectedMotions, setSelectedMotions] = useState(new Set()); // this will dicate selected motion
  const [openRuling, setOpenRuling] = useState(false);
  const [motionIndex, setMotionIndex] = useState(-1);
  const [activeMotion, setActiveMotion] = useState(null);
  const [orderTypes, setOrderTypes] = useState([]);
  const [pronouncementTypes, setPronouncementTypes] = useState([]);
  const [orderTypeId, setOrdertypeId] = useState("");
  const [motionNote, setMotionNote] = useState("");
  const [isContinue, setIsContinue] = useState(false);
  const [isMotionRuling, setIsMotionRuling] = useState(false);
  const [partiesInfavour, setPartiesInFavour] = useState(new Set());
  const [isDirectStruckOut, setIsDirectStruckOut] = useState(false);
  const [openNoteModal, setOpenNoteModal] = useState(false);
  const [motionSummary, setMotionSummary] = useState("");
  const [pronounceId, setPronunceId] = useState("");

  const [doc, setDoc] = useState("");
  const [docFile, setDocFile] = useState(null);

  const [finalDoc, setFinalDoc] = useState("");
  const [finalDocFile, setFinalDocFile] = useState(null);

  const [noteFile, setNoteFile] = useState(null);

  const [isMotionPending, setMotionPending] = useState(true);
  const [isAdjourn, setIsAdjourn] = useState(false);
  const [isAdjournSchedule, setIsAdjournSchedule] = useState(true);
  const [actionType, setActionType] = useState(""); //motion, trial, cmc
  const [eventType, setEventType] = useState("");
  const [openJudgement, setOpenJudgement] = useState(false);
  const [hearingNote, setHearingNote] = useState("");
  const [hearingStatus, setHearingStatus] = useState(false);
  const adjournByList = ["Claimant", "Defendant", "Court", "Others"];
  const [selectedAdjournby, setSelectedAdjournby] = useState(new Set());
  const [otherAdjourn, setOtherAdjourn] = useState("");
  const [adjournSchedule, setAdjournSchedule] = useState({});
  const [isAnotherday, setIsAnotherday] = useState(false);
  const [isFinal, setIsFinal] = useState(false);
  const [claimType, setClaimType] = useState("Claim");
  const [selectedClaim, setSelectedClaim] = useState(null);
  const [judgement, setJudgement] = useState({ totalAmount: 0, currency: "N" });
  const [judgements, setJudgements] = useState([]);
  const [hearingData, setHearingData] = useState({});
  const [judgementOptions, setJudgementOption] = useState({
    isFavour: true,
    isAmount: false,
    isInterest: false,
    isSentence: false,
  });
  const [clear, setClear] = useState(false);
  const [totalAmount, setTotalAmount] = useState(0);

  const [judgeNotes, setJudgeNotes] = useState([]);
  const [judgementTypes, setJudgementTypes] = useState([]);
  const [openCase, setOpenCase] = useState(false);

  const [mediation, setMediation] = useState(null);
  const [openAdopt, setOpenAdopt] = useState(false);
  const [comment, setComment] = useState("");
  const [clearType, setClearType] = useState("");
  const [action, setAction] = useState(""); //to receive response from motion verdict
  const [documents, setDocuments] = useState([]);
  const [recorderText, setRecorderText] = useState("");

  const [openDocumentPreview, setOpenDocumentPreview] = useState(false);
  const [previewUrl, setPreviewUrl] = useState("");

  const [stribeurl, setStribeurl] = useState(null);
   const [isListening, setIsListening] = useState(false);
  // recorder
  const handleNewTranscriptionText = (incomingText) => {
    setRecorderText((prevText) => {
      return prevText ? `${prevText.trim()} ${incomingText}` : incomingText;
    });
  };
 useEffect(() => {
  
  if (tab !== "recorder") return; // ❌ do nothing if not active tab

  let timer;

  const fetchLoop = async () => {
    await onLoadRecord();
    timer = setTimeout(fetchLoop, 2000);
  };

  fetchLoop();

  return () => clearTimeout(timer); // ✅ stop when tab changes/unmount
}, [tab, scheduleid]);

const onLoadRecord = async () => {
    //for account registration
    try {
     
      const resp = await fetch(
        `${Constants.apiUrl}/hearing/court-recorder/${scheduleid}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const data = await resp.json();
      
      if (data.code == 0) {
        //ready
        setRecorderText(data.note??'');
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      
      console.error(error);
    }
  };
  // end recorder

  const previewDocument = (docPath) => {
    setOpenDocumentPreview(true);
    const finalPath = Constants.RelativeFiletoRelative(docPath);
    setPreviewUrl(finalPath);
  };

  const openPreview = (url) => {
    setPreviewUrl(url);
    setOpenDocumentPreview(true);
  };

 

  const onCloseOpenAdopt = () => {
    setOpenAdopt(false);
  };

  useEffect(() => {
    onLoad();
  }, []);

  useEffect(() => {
    if (action == "close") {
      navigate("/case-scheduler");
    }
  }, [action]);

  useEffect(() => {
    setJudgement({
      pronouncedId: "",
      summary: "",
      SentenceDurationType: "",
      interestType: "",
      grantedAmount: "",
    });
    setPartiesInFavour(new Set());
    setSelectedClaim(null);
  }, [clear]);
  useEffect(() => {
    //setting total amount
    if (judgementOptions.isAmount) {
      if (judgementOptions.isInterest) {
        const from = moment(judgement.fromYear);
        const now = moment();
        const time = now.diff(from, "years");

        console.log(judgement.amountGranted);
        var amount = 0;
        if (judgement.interestType == "simple") {
          const si = (judgement.amountGranted * judgement.rate * time) / 100;
          amount = si + parseFloat(judgement.amountGranted);
        } else {
          //this has to be compound
          const compound =
            judgement.amountGranted * Math.pow(1 + judgement.rate / 100, time) -
            judgement.amountGranted;
          amount = compound + parseFloat(judgement.amountGranted);
        }
      } else {
        amount = judgement.amountGranted;
      }
      setTotalAmount(amount);
    }
  }, [judgement, judgementOptions.isInterest]);
  useEffect(() => {
    if (cinfo?.caseinfo?.caseId) {
      console.log(cinfo?.caseinfo?.caseId, "test here ");
      onLoadHearing(cinfo?.caseinfo?.caseId);
      onLoadJudgeNote(cinfo?.caseinfo?.caseId);
    }
  }, [cinfo?.caseinfo?.caseId]);

  useEffect(() => {
    console.log(cinfo.motions);
  }, [cinfo.motions]);

  useEffect(() => {
    if (hearingStatus == "Adjourned") {
      setOpenJudgement(false);
      setIsAdjourn(true);
    } else if (hearingStatus == "Dismissed") {
    }
  }, [hearingStatus]);

  const onScheduleChange = (e) => {
    setAdjournSchedule({ ...adjournSchedule, [e.target.name]: e.target.value });
  };
  const onJudgementChange = (e) => {
    if ([e.target.name] == "amountGranted") {
      const cleaned = e.target.value.replace(/,/g, "");
      setJudgement({ ...judgement, [e.target.name]: cleaned });
    } else {
      setJudgement({ ...judgement, [e.target.name]: e.target.value });
    }
  };

  const onLoad = async () => {
    //for account registration
    try {
      setLoading(true);
      const resp = await fetch(
        `${Constants.apiUrl}/filing/case-schedule-details/${scheduleid}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = await resp.json();
      setLoading(false);
      if (data.code == 0) {
        setCaseInfo(data.cinfo);
        setOrderTypes(data.rulingTypes);
        setPronouncementTypes(data.pronouncements);
        setJudgementTypes(data.judgementTypes);
setDocuments(data.cinfo.documents);
        const hasAnyUnavailable = data.cinfo.motions.some((motion) =>
          motion.prayers.some((prayer) => !prayer.isMotionDispose),
        );

        setMotionPending(hasAnyUnavailable);
setEventType(data.cinfo?.caseinfo?.judgeAs.toLowerCase());
       /*  if (data.cinfo?.caseinfo?.caseStatusId == 51) {
          setEventType("cmc");
        } else if (data.cinfo?.caseinfo?.caseStatusId == 53) {
          setEventType("trial");
        } */

        if (data.cinfo?.caseinfo?.caseTypeId == 2) {
          setClaimType("Offence");
        } else {
          setClaimType("Claim");
        }

        onLoadHearing(data.cinfo?.caseinfo?.caseId);
      } else if (data.code == -10) {
        setIsExpired(true);
      } else if (data.code == -5) {
        setAlert({
          icon: "warning",
          open: true,
          title: "Judge Re-assigned",
          subtitle: `This case is reassigned to another ${data.judgename}. Its now removed from your queue.`,
        });
        navigate("/case-scheduler");
      } else {
        //there is an error
        setErr(data.status);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  const onLoadHearing = async (caseid) => {
    //for account registration
    try {
      setLoading(true);
      const resp = await fetch(
        `${Constants.apiUrl}/hearing/hearing-by-case/${caseid}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const data = await resp.json();
      setLoading(false);
      if (data.code == 0) {
        setHearingData({
          hearing: data.hearing,
          motionruling: data.motionruling,
          motionFavours: data.motionFavours,
          claimruling: data.claimruling,
          claimfavour: data.claimfavour,
        });
        setMediation(data.mediation);

        console.log(`during hearing details ${data.hearing.id}`);
      } else if (data.code == -10) {
        setIsExpired(true);
      } else if (data.code == -21 || data.code == -22) {
        // not the case's judge (e.g. a JA): the Judgement tab stays restricted, but the
        // Final Judgement dialog still needs the pronouncements already given per claim
        onLoadClaimRulings(caseid);
      } else {
        //there is an error
        setErr(data.status);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  const onLoadClaimRulings = async (caseid) => {
    try {
      const resp = await fetch(`${Constants.apiUrl}/hearing/claim-rulings/${caseid}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await resp.json();
      if (data.code == 0) {
        setHearingData((prev) => ({
          ...prev,
          claimruling: data.claimruling,
          claimfavour: data.claimfavour,
        }));
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      console.error(error);
    }
  };
  const onAppenDocument = async (event) => {
    const input = event.target;

    if (input.files && input.files[0]) {
      const file = input.files[0];
      const b64 = await Constants.toBase64(file); // must return base64 as string

      const obj = {
        open: true,
        data: b64.split(",")[1],
        file: file,
        filename: file.name,
      };

      setNoteFile(obj);

      console.log("File read successfully");
      console.log("Filename:", file.name);
      console.log("Base64:", b64);
    }
  };
  const onAppendMotionDocument = async (event) => {
    const input = event.target;

    if (input.files && input.files[0]) {
      const file = input.files[0];
      const b64 = await Constants.toBase64(file); // must return base64 as string
      var path = URL.createObjectURL(file);
      var fname = Constants.ReduceFilename(file?.name);
      const obj = {
        open: true,
        data: b64.split(",")[1],
        file: fname,
        filename: file.name,
        path,
      };

      setDoc(b64);
      setDocFile(obj);

      console.log("File read successfully");
      console.log("Filename:", file.name);
      console.log("Base64:", b64);
    }
  };

  const onAppendFinalDocument = async (event) => {
    const input = event.target;

    if (input.files && input.files[0]) {
      const file = input.files[0];
      const b64 = await Constants.toBase64(file); // must return base64 as string
      const path = URL.createObjectURL(file);

      const obj = {
        open: true,
        data: b64,
        file: file,
        filename: file.name,
        path,
      };

      setFinalDoc(b64);
      setFinalDocFile(obj);

      console.log("File read successfully");
      console.log("Filename:", file.name);
      console.log("Base64:", b64);
    }
  };
  const onSelectPrayer = (pindex, prayer, index, value) => {
    console.log(`motion: ${pindex} prayer: ${index} value: ${value}`);
    var _motions = [...cinfo.motions];

    _motions[pindex].prayers[index].selected = value;
    console.log(_motions);
    setCaseInfo({ ...cinfo, motions: _motions });
  };
  const onSelectClaim = (claim, index, value) => {
    console.log(`claim:  ${index} value: ${value}`);
    var _claims = [...cinfo.claims];

    _claims[index].selected = value;
    console.log(_claims);
    setCaseInfo({ ...cinfo, claims: _claims });
  };

  const onMotionRuling = (motion, index) => {
    //first check if any of it prayers is selected
    //secondly open a form dialog
    const selectedprayer = motion.prayers.filter((e) => e.selected);
    if (selectedprayer.length == 0) {
      setAlert({
        icon: "warning",
        open: true,
        title: "Note",
        subtitle: "Please select one of the Prayers for ruling",
      });
      return;
    }
    //check if any motion with order 49 is still pending and this Prayer not from it, then insiste it must be sorted first
    var ms = cinfo?.motions?.filter((d) => (d.motionTypeId == 10 || d.motionTypeId == 24)); //checking any available order 49
    if (ms.length > 0) {
      //order 49exist
      console.log("order 49 exist in this Hearing");
     
      //check if all its prayers are deposed
      var ps = ms[0].prayers.filter((e) => !e.isMotionDispose);
      if (ps.length > 0 && ms[0].id != motion.id) {
        setAlert({
          icon: "warning",
          open: true,
          title: "Note",
          subtitle: "Please pass ruling on the pending Order 49 first",
        });
        return;
      }
    }
    //

    setOpenRuling(true);
    setMotionIndex(index);
    setActiveMotion(motion);
    setActionType("motion");
    setMotionNote("");
    setDocFile(null);
  };

  const onMainCaseRuling = () => {
    if (judgeNotes?.length === 0) {
      setOpenNoteModal(true);
    } else {
      setActionType(eventType);
      setOpenJudgement(true);
    }
  };

  const onDeposeMotion = () => {
    if (motionNote.trim() == "" && docFile == null) {
      setAlert({
        icon: "warning",
        open: true,
        title: "Warning",
        subtitle:
          "Please enter either Motion Report or select Front Load Motion Report.",
      });
      return;
    }

    if (orderTypeId == "") {
      setAlert({
        icon: "warning",
        open: true,
        title: "Warning",
        subtitle: "Please select the ruling option to continue",
      });
      return;
    }

    setIsContinue(true);
    setOpenRuling(false);
  };

  const onContinueRuling = async () => {
    setOpenRuling(false);
    setIsContinue(false);
    setOpenJudgement(false);

    console.log("action type " + actionType);
    if (actionType == "motion") {
      if (orderTypeId == 3) {
        //this is a struck out case
        //passing the judgement like that
        await onVerdict();
        setAlert({
          open: true,
          title: "Order Ruling",
          subtitle: "Prayer(s) Struck out",
        });
      } else if (orderTypeId == 9 || orderTypeId == 10) {
        await onVerdict();
        setAlert({
          open: true,
          title: "Order Ruling",
          subtitle: `${
            orderTypeId == 9
              ? "Case Suitable for Vacation."
              : "Case Not Suitable for Vacation"
          }`,
        });
        //case to
        if (orderTypeId == 10) {
          //navigate("/case-scheduler"); //app redirect to calender
          navigate('/adr-judge-cases');
        }
      } else {
        setIsMotionRuling(true);
      }
    } else {
      const resp = await onSaveHearing("judgement");
      if (!resp || resp.code !== 0) return;

      const dismissedStatuses = [
        "Dismissed",
        "Withdraw",
        "Struck out",
        "Closed",'Not Settled'
      ];

      if (dismissedStatuses.includes(hearingStatus)) {
        // Judgement and conclude.. nothing on the claims or offences
        setAlert({
          open: true,
          title: "",
          subtitle: `${hearingStatus === "Closed" ? "CMC" : "Case"} ${hearingStatus} Successfully`,
          // hearingStatus.toLowerCase() === "struck out"
          //   ? "Case Struck Out Successfully"
          //   : "Case Dismissed Successfully",
          onOk: () => navigate("/case-scheduling/cmc"),
        });
        onLoad();
      } else if (hearingStatus == "FinalJudgement" || hearingStatus == "Settled") {
        // Judgement and conclude
        setIsFinal(true);
      }
    }
  };
  const onCancelRuling = () => {
    if (actionType == "motion") {
      setOpenRuling(true);
    } else {
      setOpenJudgement(true);
    }
    setIsContinue(false);
  };

  const onFavourPick = (party) => {
    const pf = new Set(partiesInfavour);

    if (pf.has(party.id)) {
      pf.delete(party.id);
    } else {
      pf.add(party.id);
    }

    setPartiesInFavour(new Set(pf));
  };
  const onAdjournByPick = (index) => {
    const pf = new Set(selectedAdjournby);

    if (pf.has(index)) {
      pf.delete(index);
    } else {
      pf.add(index);
    }

    setSelectedAdjournby(new Set(pf));
  };

  const onFinalJudgement = async () => {
    if (judgement.judgementType == "") {
      setAlert({
        icon: "warning",
        open: true,
        title: "Warning",
        subtitle: "Please select final conclusion type",
      });
      return;
    }
    if (judgement.judgementTypeId == "") {
      setAlert({
        icon: "warning",
        open: true,
        title: "Warning",
        subtitle: "Please select final judgement type",
      });
      return;
    }

    setLoading(true);

    try {
      var req = {
        ScheduleId: scheduleid,
        Doc: finalDocFile?.data,
        docFilename: finalDocFile?.filename,
        HearingId: hearingId,
        isContested: judgement.isContested ?? false,
        Conclusion: judgement.judgementType,
        witness: judgement.witness,
        judgementTypeId: judgement.judgementTypeId,
      };
      const resp = await fetch(`${Constants.apiUrl}/hearing/final-judgement`, {
        method: "POST",
        body: JSON.stringify(req),
        headers: {
          "Content-Type": "application/json, text/plain",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await resp.json();
      setLoading(false);
      console.log(data);
      if (data.code === 0) {
        setIsContinue(false);
        setOpenRuling(false);
        setAlert({
          open: true,
          title: "Final Judgement",
          subtitle: "Case concluded successfully",
        });
        navigate(`/case-scheduling/${eventType}`);
      } else {
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      // setErr(Constants.serverErr);
      // onMove();
    }
  };

  const onSaveNote = async () => {
    console.log(scheduleid, "here is schedule id");
    if (judgenote?.trim() == "" && noteFile == null) {
      setAlert({
        icon: "warning",
        open: true,
        title: "Warning",
        subtitle: "Please enter judge note or upload file",
      });
      return;
    }

    setLoading(true);

    try {
      var req = {
        ScheduleId: scheduleid,
        Doc: noteFile?.data,
        docFilename: noteFile?.filename,
        note: judgenote,
      };
      const resp = await fetch(`${Constants.apiUrl}/hearing/hearing-note`, {
        method: "POST",
        body: JSON.stringify(req),
        headers: {
          "Content-Type": "application/json, text/plain",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await resp.json();
      setLoading(false);
      console.log(data, "find it here !");
      if (data.code === 0) {
        setIsContinue(false);
        setOpenRuling(false);
        setAlert({
          open: true,
          title: "Judge Note",
          subtitle: "Judge Note saved successfully",
        });
        setNoteFile(null);
        onLoadJudgeNote(cinfo?.caseinfo?.caseId);
      } else {
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      // setErr(Constants.serverErr);
      // onMove();
    }
  };

  const onVerdict = async () => {
    //sendinh hearing details with what is available

    setLoading(true);
    var prayerIds = activeMotion.prayers
      .filter((d) => d.selected)
      .map((d) => d.id);
    try {
      var req = {
        ScheduleId: scheduleid,
        MotionId: activeMotion.id,
        PrayerIds: prayerIds,
        FavourIds: Array.from(partiesInfavour),
        MotionNote: motionNote,
        MotionSummary: motionSummary,
        Doc: docFile?.data,
        docFilename: docFile?.filename,
        OrderTypeId: orderTypeId,
        PronouceId: pronounceId,
      };
      const resp = await fetch(`${Constants.apiUrl}/hearing/motion`, {
        method: "POST",
        body: JSON.stringify(req),
        headers: {
          "Content-Type": "application/json, text/plain",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await resp.json();
      setLoading(false);
      console.log(data);
      if (data.code === 0) {
        setIsContinue(false);
        setOpenRuling(false);
        setIsMotionRuling(false);
        setHearingId(data.id);
        setStribeurl(`${Constants.apiUrl}/hearing/transcribe-judge-note/${scheduleid}/${data.id}`);
        console.log(`during motion saving ${data.id}`);
        setAction(data.action);
        setAlert({
          open: true,
          title: "Motion Hearing",
          subtitle: "Motion hearing saved successfully",
        });

        onLoad();
      } else {
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      // setErr(Constants.serverErr);
      // onMove();
    }
  };

  const onSaveAdjournment = async (e) => {
    e.preventDefault();
    //sendinh hearing details with what is available

    setLoading(true);

    const result = Array.from(selectedAdjournby)
      .filter((index) => index !== 3) // Skip index 3
      .map((index) => adjournByList[index])
      .join(", ");
    const AdjournedBy = result + "," + otherAdjourn;
    try {
      var req = {
        ScheduleId: scheduleid,
        ...adjournSchedule,
        AdjournedBy,
        IsDateSchedule: isAdjournSchedule,
      };
      const resp = await fetch(`${Constants.apiUrl}/hearing/adjorn-hearing`, {
        method: "POST",
        body: JSON.stringify(req),
        headers: {
          "Content-Type": "application/json, text/plain",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await resp.json();
      setLoading(false);
      console.log(data);
      if (data.code === 0) {
        setIsContinue(false);
        setOpenRuling(false);
        setIsMotionRuling(false);
        setIsAdjourn(false);

        setAlert({
          open: true,
          title: "Adjourn",
          subtitle: "Hearing Adjourned successfully",
        });
        navigate(`/case-scheduling/${eventType}`);
      } else {
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      // setErr(Constants.serverErr);
      // onMove();
    }
  };

  const onSaveHearing = async (initiator) => {
    //sendinh hearing details with what is available

    setLoading(true);

    try {
      // var hnote=initiator=='judgement'?hearingNote:motionNote;
      var req = {
        ScheduleId: scheduleid,
        Summary: hearingNote,
        Doc: doc,
        HearingStatus: hearingStatus,
        initiator: initiator,
        isDateSchedule: isAnotherday,
        docFilename: docFile?.filename,
        ...adjournSchedule,
      };
      const resp = await fetch(`${Constants.apiUrl}/hearing/save-hearing`, {
        method: "POST",
        body: JSON.stringify(req),
        headers: {
          "Content-Type": "application/json, text/plain",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await resp.json();
      setLoading(false);
      console.log(data);
      if (data.code === 0) {
        //proceed to next page
        // setAlert({open:true, title:'Motion Hearing', subtitle:'Motion hearing saved successfully'})
        setHearingId(data.id);
        setStribeurl(`${Constants.apiUrl}/hearing/transcribe-judge-note/${scheduleid}/${data.id}`);
        console.log(`during saving hearing ${data.id}`);
        // setAction(data.action);
      } else {
      }
      return data;
    } catch (error) {
      setLoading(false);
      console.error(error);
      // setErr(Constants.serverErr);
      // onMove();
    }
  };

  const onLoadJudgeNote = async (caseid) => {
    console.log(caseid, "compare case id with schedule id");
    try {
      setLoading(true);
      const resp = await fetch(
        `${Constants.apiUrl}/hearing/judge-notes/${caseid}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = await resp.json();
      setLoading(false);
      if (data.code == 0) {
        console.log(data.notes);
        setJudgeNotes(data.notes);
      } else if (data.code == -10) {
        setIsExpired(true);
      } else {
        //there is an error
        setErr(data.status);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  const onAdjourn = () => {
    setIsAdjourn(true);
  };

  const onMainDeposeJudgement = async (e) => {
    e.preventDefault();
   /*  if(hearingStatus=="Settled"){

      
    }else if (hearingStatus == "Not Settled") {

    } */
    setIsContinue(true);
    setOpenJudgement(false);
  };

  const onMainVerdict = async () => {
    setLoading(true);
    var prayerIds = activeMotion.prayers
      .filter((d) => d.selected)
      .map((d) => d.id);
    try {
      var req = {
        ScheduleId: scheduleid,
        MotionId: activeMotion.id,
        PrayerIds: prayerIds,
        FavourIds: Array.from(partiesInfavour),
        MotionNote: motionNote,
        MotionSummary: motionSummary,
        Doc: doc,
        OrderTypeId: orderTypeId,
        PronouceId: pronounceId,
      };
      const resp = await fetch(`${Constants.apiUrl}/hearing/motion`, {
        method: "POST",
        body: JSON.stringify(req),
        headers: {
          "Content-Type": "application/json, text/plain",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await resp.json();
      setLoading(false);
      console.log(data);
      if (data.code === 0) {
        setIsContinue(false);
        setOpenRuling(false);
        setAlert({
          open: true,
          title: "Motion Hearing",
          subtitle: "Motion hearing saved successfully",
        });
        onLoad();
      } else {
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      // setErr(Constants.serverErr);
      // onMove();
    }
  };

  const onJudgement = async (e) => {
    e.preventDefault();

    //check if favour is selected
    if (selectedClaim == null) {
      setAlert({
        icon: "warning",
        open: true,
        title: "Note",
        subtitle: "Please select the claim.",
      });
      return;
    }
    if (partiesInfavour.size == 0) {
      setAlert({
        icon: "warning",
        open: true,
        title: "Note",
        subtitle: "Please select the party",
      });
      return;
    }
    try {
      setLoading(true);
      const partiesid = Array.from(partiesInfavour);
      var party = cinfo?.parties.filter((d) => d.id == partiesid[0])[0];

      const pronouncement = pronouncementTypes.find(
        (e) => e.id == judgement.pronouncedId,
      )?.title;
      var req = {
        ...judgement,
        hearingId: hearingId,
        scheduleId: scheduleid,
        claimId: selectedClaim.id,
        favourPartyId: party.id,
        FavourLegalCounselId: party.legalCounselId,
        pronouncement: pronouncement,
        ...judgementOptions,
      };

      console.log(req);

      const resp = await fetch(`${Constants.apiUrl}/hearing/add-judgement`, {
        method: "POST",
        body: JSON.stringify(req),
        headers: {
          "Content-Type": "application/json, text/plain",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await resp.json();
      setLoading(false);
      console.log(data);
      if (data.code === 0) {
        setAlert({
          open: true,
          title: "Judgement",
          subtitle: "Pronouncement done successfully",
        });
        onLoad(); //reload all

        setClear(!clear);
      } else {
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      // setErr(Constants.serverErr);
      // onMove();
    }
  };
  const onContinue = (caseid) => {
    navigate(`/case-details/${caseid}`);

    // setOpenCase(true);
  };
  const onCloseOpenCase = () => {
    setOpenCase(false);
  };

  const onSaveAdr = async (e) => {
    e.preventDefault();
    setLoading(true);
    var approve = { caseid: cinfo?.caseinfo?.caseId, comment: comment };
    try {
      const resp = await fetch(
        `${Constants.apiUrl}/hearing/adr-clear/${scheduleid}/${clearType}`,
        {
          method: "POST",
          body: JSON.stringify(approve),
          headers: {
            "Content-Type": "application/json, text/plain",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = await resp.json();
      setLoading(false);
      console.log(data);
      if (data.code == 0) {
        //update the field

        setOpenAdopt(false);
        if (clearType == "adoption") {
          setAlert({
            open: true,
            title: "Settlement Adopted",
            subtitle: " Cases cleared  successfully",
          });
        } else if (clearType == "struckout") {
          setAlert({
            open: true,
            title: "Case struck-Out",
            subtitle: " Cases struck-out  successfully",
          });
        }

        navigate("/case-scheduler");
      } else if (data.code == -10) {
        setIsExpired(true);
      } else {
        //there is an error
        setErr(data.status);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      setErr(Constants.serverErr);
      // onMove();
    }
  };

  const onDirectStruckOut = () => {
    //setOpenAdopt(true);setClearType('struckout')
    setOpenJudgement(true);
    setHearingStatus("Struck out");
    setIsDirectStruckOut(true);
  };

  const formatFileSize = (bytes) => {
    if (bytes < 1024) return bytes + " B";
    if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + " KB";
    return (bytes / (1024 * 1024)).toFixed(1) + " MB";
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.currentTarget.classList.add("drag-over");
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.currentTarget.classList.remove("drag-over");
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.currentTarget.classList.remove("drag-over");
    const files = e.dataTransfer.files;
    if (files.length > 0) {
      onAppenDocument({ target: { files } });
    }
  };

  const formatTime12Hour = (time) => {
    if (!time) return null;
    return new Date(`1970-01-01T${time}`).toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  };

  const onViewSettlement=()=>{
    //get the main file in question
    const termsettle = documents.find(d =>d.title?.toLowerCase().includes('settlement'));
   console.log(termsettle);
   var finalpath='';
   if(termsettle!=null ){
    if(termsettle.documentLocation=='template'){
      finalpath = `${Constants.baseurl}/template-live-document/${termsettle.id}`;
    }else{
       finalpath = Constants.RelativeFiletoRelative(
              Constants.getDocumentPath(termsettle)
            );
    }
    openPreview(finalpath);
   }
   // 
  }
 const onStatusChange = (isActive) => {
    console.log("Voice Engine Active:", isActive);
     setIsListening(isActive);
  };

  return (
    <div>
      <div className="hearing-header ">
        <h2>Hearing</h2>
        <div className="hearing-button-group">
          <JisButton onClick={onAdjourn}>Adjourn Case</JisButton>{" "}
          <JisButton onClick={onDirectStruckOut}>Struck Out</JisButton>
        </div>
      </div>
      <div className="tab_body">
        <div
          className="tab_section"
          style={{ display: "flex", marginBottom: "20px" }}
        >
          <JisTabButton
            code="caseinfo"
            isActive={tab == "caseinfo"}
            title="Case Details"
            data={null}
            isRoleBased={false}
            onClick={() => setTab("caseinfo")}
          />
          {/*   <JisTabButton code="casedocuments" isActive={tab=='casedocuments'}  title="Documents" data={null} isRoleBased={false}  onClick={()=> setTab('casedocuments')}/>   */}
          <JisTabButton
            code="judgenote"
            isActive={tab == "judgenote"}
            title="Judge Note"
            data={null}
            isRoleBased={false}
            onClick={() => setTab("judgenote")}
          />
          <JisTabButton
            code="recorder"
            isActive={tab == "recorder"}
            title="Court Recorder's Note"
            data={null}
            isRoleBased={false}
            onClick={() => setTab("recorder")}
          />
          <JisTabButton
            code="ruling"
            isActive={tab == "ruling"}
            title="Hearing Details"
            data={null}
            isRoleBased={false}
            onClick={() => setTab("ruling")}
          />
        </div>
        {tab == "caseinfo" && (
          <div className="tab_view">
            <section class="case-info">
              <div className="summary summary_wrapper hearing_summary">
                <div>
                  <p className="label">Parties to the Case</p>
                  <p className="value">{cinfo?.caseinfo?.caseTitle}</p>
                </div>
                <div>
                  <p className="label">Suite Number</p>

                  <p className="value">{cinfo?.caseinfo?.caseNumber}</p>
                </div>
                <div>
                  <p className="label">Case of Origin</p>
                  <p className="value">
                    {
                      Constants.getItemById(
                        frequentData?.caseorigin,
                        cinfo?.caseinfo?.caseOriginId,
                      )?.title
                    }
                  </p>
                </div>
                <div>
                  <p className="label">Division</p>
                  <p className="value">
                    {
                      Constants.getItemById(
                        frequentData?.divisions,
                        cinfo?.caseinfo?.divisionId,
                      )?.title
                    }
                  </p>
                </div>
                <div>
                  <p className="label">Classification</p>

                  <p className="value">
                    {
                      Constants.getItemById(
                        frequentData?.casecategories,
                        cinfo?.caseinfo?.caseCategoryId,
                      )?.categoryTitle
                    }
                  </p>
                </div>
                <div>
                  <p className="label">Date Initiated</p>
                  <p className="value">
                    {Constants.momentDate(cinfo?.caseinfo?.createdOn)?.format(
                      "DD MMM, YYYY",
                    )}
                  </p>
                </div>
                <div>
                  <p className="label">Case Type</p>

                  <p className="value">
                    {
                      Constants.getItemById(
                        frequentData?.casetype,
                        cinfo?.caseinfo?.caseTypeId,
                      )?.caseType1
                    }
                  </p>
                </div>
                <div>
                  <p className="label">Case Status</p>

                  <p className="value">
                    {
                      Constants.getItemById(
                        frequentData?.casestatuses,
                        cinfo?.caseinfo?.caseStatusId,
                      )?.description
                    }
                  </p>
                </div>
                <div>
                  <p className="label">Filing Type</p>

                  <p className="value">
                    {
                      Constants.getItemById(
                        frequentData?.filingtypes,
                        cinfo?.caseinfo?.caseFilingId,
                      )?.title
                    }
                  </p>
                </div>

                <div
                  style={{ textAlign: "right" }}
                  className="case-document-button-container"
                >
                  <JisButton
                    onClick={() => onContinue(cinfo?.caseinfo?.caseId)}
                  >
                    Case Documents
                  </JisButton>
                </div>
              </div>
              {/* <div style={{ textAlign: "right" }}>
                  <JisButton onClick={() => onContinue()}>
                    Case Documents
                  </JisButton>
                </div> */}
              <hr />
              {cinfo?.caseinfo?.caseFilingId == 2 &&
                mediation != null &&
                mediation.partiesSettled && (
                  <div className="panel">
                    <div className="title"> Case Ready for Adoption</div>
                    <div className="panel-body">
                      <div>
                        <span> Summary: </span>
                        <span style={{ fontStyle: "italic" }}>
                          {mediation?.summary}
                        </span>
                      </div>
                      <div>
                        <div style={{ textAlign: "right" }}>
                          <JisButton type="button"
                            onClick={() => {
                              setOpenAdopt(true);
                              setClearType("adoption");
                            }}
                          >
                            Term of Settlement Adoption
                          </JisButton>
                          <JisButton type="button"
                            onClick={onViewSettlement}
                          >
                           View Term of Settlement
                          </JisButton>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

              <div className="wide">
                <div>
                  <h3>Cause of Actions</h3>
                  <div style={{ display: "flex" }}>
                    {cinfo?.causes?.map((opt) => (
                      <div key={opt.id} className="selected">
                        <strong>{opt.description}</strong>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </section>

            <div
              className="table"
              style={{ marginBottom: "24px", marginTop: "24px" }}
            >
              <div class="table-header  ">
                <span>Claims Details</span>
              </div>
              {claimType == "Claim" && (
                <div className="table-wrapper">
                  <table className="case-details-table">
                    <thead>
                      <tr>
                        <th className="col-title">ClaimDescription</th>
                        <th>Claim Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      {cinfo?.claims?.map((opt, index) => (
                        <tr key={opt.id}>
                          <td> {opt.claim || "N/A"}</td>
                          <td>
                            {opt.currencyType || opt.claimValue ? (
                              <>
                                <strong>{opt.currencyType}</strong>{" "}
                                {Constants.formatCurrency(opt.claimValue)}
                              </>
                            ) : (
                              "N/A"
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
              {claimType != "Claim" && (
                <table className="case-table">
                  <thead>
                    <tr>
                      <th className="col-title">Offence Description</th>
                    </tr>
                  </thead>
                  <tbody>
                    {cinfo?.claims?.map((opt, index) => (
                      <tr key={opt.id}>
                        <td> {opt.claim || "N/A"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>

            {cinfo?.caseinfo?.caseFilingId == 1 && !isMotionPending && (
              <div style={{ textAlign: "right" }}>
                <JisButton onClick={onMainCaseRuling}>
                  {eventType?.toUpperCase()} Pronoucement/Judgement
                </JisButton>
              </div>
            )}

            <div className="hearing-prayer-container">
              <div className="table-header">
                <p>Motion </p>
              </div>
              <div className="hearing-prayer-child-container">
                {cinfo?.motions?.map((opt, pindex) => (
                  <div
                    key={opt.id}
                    style={{ marginTop: pindex !== 0 ? "16px" : 0 }}
                  >
                    <div className="hearing-prayer-container-heading">
                      <p
                        style={{
                          textTransform: "capitalize",
                        }}
                      >
                        Party Name:{" "}
                        {opt.party.firstName || opt.party.lastName
                          ? `${opt.party.firstName} ${opt.party.lastName}`
                          : "N/A"}
                      </p>
                      <p>Motion Type: {opt.motiontype ?? "N/A"}</p>
                      <p>
                        Date Filed:{" "}
                        {Constants.momentDate(opt.createdOn).format(
                          "DD MMM, YYYY",
                        ) ?? "N/A"}{" "}
                      </p>
                      <p>Classification : {opt.motionClass ?? "N/A"}</p>
                    </div>

                    <p className="hearing-prayer-paragraph">Prayers</p>

                    {opt.prayers?.map((pray, index) => (
                      <div
                        key={pray.id}
                        className="hearing-prayer-checkbox-group"
                      >
                        <input
                          type="checkbox"
                          id={pray.id}
                          onChange={(e) =>
                            onSelectPrayer(
                              pindex,
                              pray,
                              index,
                              e.target.checked,
                            )
                          }
                          disabled={pray.isMotionDispose}
                          checked={pray.selected || pray.isMotionDispose}
                        />
                        <label htmlFor={pray.id}>
                          {`${pray.prayer}`.replace(")", "")}
                        </label>
                      </div>
                    ))}

                    <div
                      style={{ textAlign: "right" }}
                      className="case-document-button-container"
                    >
                      {opt.prayers.filter((e) => !e.isMotionDispose).length >
                      0 ? (
                        <JisButton
                          onClick={() => onMotionRuling(opt, pindex)}
                          variant="primary"
                        >
                          Order/Ruling
                        </JisButton>
                      ) : (
                        <p>Order Given</p>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            
            <div className="table">
              <div class="table-header">
                <span>Legal Counsel</span>
              </div>
              <div className="table-wrapper">
                <table className="case-details-table">
                  <thead>
                    <tr>
                      <th>First name</th>
                      <th>Last Name</th>
                      <th>Phone</th>
                      <th className="col-title">Email</th>
                    </tr>
                  </thead>
                  <tbody>
                    {cinfo?.legalcounsels?.map((opt, ind) => (
                      <tr key={ind}>
                        <td>{opt?.firstName}</td>
                        <td>{opt?.lastName ?? ""}</td>
                        <td>{opt?.primaryContactNumber}</td>
                        <td>{opt?.primaryEmail}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}
        {tab == "judgenote" && (
          <div className="tab_view">
            <div>
              <div className="input-group  judge-note-input-wrapper">
                <label htmlFor="judge-note">Judge’s Note</label>
                <div className="input-wrapper">
                  <textarea
                    id="judge-note"
                    placeholder="Add Note"
                    required={true}
                    value={judgenote}
                    style={{ height: 300 }}
                    onChange={(e) => setJudgeNote(e.target.value)}
                  />
                </div>
              </div>

              <div className="input-group ">
                <label htmlFor="judge-note">Upload file</label>
                <div
                  onDragOver={handleDragOver}
                  onDragLeave={handleDragLeave}
                  onDrop={handleDrop}
                  className="input-wrapper judge-note-upload-wrapper"
                >
                  {noteFile ? (
                    <div className="file-selected">
                      <div
                        style={{
                          marginBottom: "20px",
                        }}
                        className=""
                      >
                        <svg
                          className="mx-auto"
                          xmlns="http://www.w3.org/2000/svg"
                          width={32}
                          height={32}
                          viewBox="0 0 40 40"
                          fill="none"
                        >
                          <g id="File">
                            <path
                              id="icon"
                              d="M31.6497 10.6056L32.2476 10.0741L31.6497 10.6056ZM28.6559 7.23757L28.058 7.76907L28.058 7.76907L28.6559 7.23757ZM26.5356 5.29253L26.2079 6.02233L26.2079 6.02233L26.5356 5.29253ZM33.1161 12.5827L32.3683 12.867V12.867L33.1161 12.5827ZM31.8692 33.5355L32.4349 34.1012L31.8692 33.5355ZM24.231 11.4836L25.0157 11.3276L24.231 11.4836ZM26.85 14.1026L26.694 14.8872L26.85 14.1026ZM11.667 20.8667C11.2252 20.8667 10.867 21.2248 10.867 21.6667C10.867 22.1085 11.2252 22.4667 11.667 22.4667V20.8667ZM25.0003 22.4667C25.4422 22.4667 25.8003 22.1085 25.8003 21.6667C25.8003 21.2248 25.4422 20.8667 25.0003 20.8667V22.4667ZM11.667 25.8667C11.2252 25.8667 10.867 26.2248 10.867 26.6667C10.867 27.1085 11.2252 27.4667 11.667 27.4667V25.8667ZM20.0003 27.4667C20.4422 27.4667 20.8003 27.1085 20.8003 26.6667C20.8003 26.2248 20.4422 25.8667 20.0003 25.8667V27.4667ZM23.3337 34.2H16.667V35.8H23.3337V34.2ZM7.46699 25V15H5.86699V25H7.46699ZM32.5337 15.0347V25H34.1337V15.0347H32.5337ZM16.667 5.8H23.6732V4.2H16.667V5.8ZM23.6732 5.8C25.2185 5.8 25.7493 5.81639 26.2079 6.02233L26.8633 4.56274C26.0191 4.18361 25.0759 4.2 23.6732 4.2V5.8ZM29.2539 6.70608C28.322 5.65771 27.7076 4.94187 26.8633 4.56274L26.2079 6.02233C26.6665 6.22826 27.0314 6.6141 28.058 7.76907L29.2539 6.70608ZM34.1337 15.0347C34.1337 13.8411 34.1458 13.0399 33.8638 12.2984L32.3683 12.867C32.5216 13.2702 32.5337 13.7221 32.5337 15.0347H34.1337ZM31.0518 11.1371C31.9238 12.1181 32.215 12.4639 32.3683 12.867L33.8638 12.2984C33.5819 11.5569 33.0406 10.9662 32.2476 10.0741L31.0518 11.1371ZM16.667 34.2C14.2874 34.2 12.5831 34.1983 11.2872 34.0241C10.0144 33.8529 9.25596 33.5287 8.69714 32.9698L7.56577 34.1012C8.47142 35.0069 9.62375 35.4148 11.074 35.6098C12.5013 35.8017 14.3326 35.8 16.667 35.8V34.2ZM5.86699 25C5.86699 27.3344 5.86529 29.1657 6.05718 30.593C6.25217 32.0432 6.66012 33.1956 7.56577 34.1012L8.69714 32.9698C8.13833 32.411 7.81405 31.6526 7.64292 30.3798C7.46869 29.0839 7.46699 27.3796 7.46699 25H5.86699ZM23.3337 35.8C25.6681 35.8 27.4993 35.8017 28.9266 35.6098C30.3769 35.4148 31.5292 35.0069 32.4349 34.1012L31.3035 32.9698C30.7447 33.5287 29.9863 33.8529 28.7134 34.0241C27.4175 34.1983 25.7133 34.2 23.3337 34.2V35.8ZM32.5337 25C32.5337 27.3796 32.532 29.0839 32.3577 30.3798C32.1866 31.6526 31.8623 32.411 31.3035 32.9698L32.4349 34.1012C33.3405 33.1956 33.7485 32.0432 33.9435 30.593C34.1354 29.1657 34.1337 27.3344 34.1337 25H32.5337ZM7.46699 15C7.46699 12.6204 7.46869 10.9161 7.64292 9.62024C7.81405 8.34738 8.13833 7.58897 8.69714 7.03015L7.56577 5.89878C6.66012 6.80443 6.25217 7.95676 6.05718 9.40704C5.86529 10.8343 5.86699 12.6656 5.86699 15H7.46699ZM16.667 4.2C14.3326 4.2 12.5013 4.1983 11.074 4.39019C9.62375 4.58518 8.47142 4.99313 7.56577 5.89878L8.69714 7.03015C9.25596 6.47133 10.0144 6.14706 11.2872 5.97592C12.5831 5.8017 14.2874 5.8 16.667 5.8V4.2ZM23.367 5V10H24.967V5H23.367ZM28.3337 14.9667H33.3337V13.3667H28.3337V14.9667ZM23.367 10C23.367 10.7361 23.3631 11.221 23.4464 11.6397L25.0157 11.3276C24.9709 11.1023 24.967 10.8128 24.967 10H23.367ZM28.3337 13.3667C27.5209 13.3667 27.2313 13.3628 27.0061 13.318L26.694 14.8872C27.1127 14.9705 27.5976 14.9667 28.3337 14.9667V13.3667ZM23.4464 11.6397C23.7726 13.2794 25.0543 14.5611 26.694 14.8872L27.0061 13.318C26.0011 13.1181 25.2156 12.3325 25.0157 11.3276L23.4464 11.6397ZM11.667 22.4667H25.0003V20.8667H11.667V22.4667ZM11.667 27.4667H20.0003V25.8667H11.667V27.4667ZM32.2476 10.0741L29.2539 6.70608L28.058 7.76907L31.0518 11.1371L32.2476 10.0741Z"
                              fill="#737373"
                            />
                          </g>
                        </svg>
                        <div>
                          <p>{noteFile.filename}</p>
                          <p className="upload-image-requirement">
                            {formatFileSize(noteFile.file.size)}
                          </p>
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "20px",
                        }}
                        className="file-action-btns"
                      >
                        <button
                          type="button"
                          style={{
                            display: "flex",
                            gap: "10px",
                            alignItems: "center",
                          }}
                          className="btn-preview"
                          onClick={() =>
                            openPreview(URL.createObjectURL(noteFile.file))
                          }
                        >
                          Preview Document
                        </button>
                        <button
                          type="button"
                          className="file-remove-btn"
                          onClick={() => setNoteFile(null)}
                        >
                          <DynamicIcon iname="x" size={16} /> Remove
                        </button>
                      </div>
                    </div>
                  ) : (
                    <>
                      <input
                        type="file"
                        id="judge-doc"
                        accept=".pdf, .doc, .docx"
                        onChange={onAppenDocument}
                      />
                      <svg
                        width={32}
                        height={32}
                        viewBox="0 0 32 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M16.9441 3.05752C16.4234 2.53682 15.5792 2.53682 15.0585 3.05752L9.72516 8.39085C9.20446 8.91155 9.20446 9.75577 9.72516 10.2765C10.2459 10.7972 11.0901 10.7972 11.6108 10.2765L14.668 7.21928V22.667C14.668 23.4034 15.2649 24.0003 16.0013 24.0003C16.7377 24.0003 17.3346 23.4034 17.3346 22.667V7.21928L20.3918 10.2765C20.9125 10.7972 21.7567 10.7972 22.2774 10.2765C22.7981 9.75577 22.7981 8.91155 22.2774 8.39085L16.9441 3.05752Z"
                          fill="#737373"
                        />
                        <path
                          d="M5.33464 23.3337C5.33464 22.5973 4.73768 22.0003 4.0013 22.0003C3.26492 22.0003 2.66797 22.5973 2.66797 23.3337V25.3337C2.66797 28.2792 5.05578 30.667 8.0013 30.667H24.0013C26.9468 30.667 29.3346 28.2792 29.3346 25.3337V23.3337C29.3346 22.5973 28.7377 22.0003 28.0013 22.0003C27.2649 22.0003 26.668 22.5973 26.668 23.3337V25.3337C26.668 26.8064 25.4741 28.0003 24.0013 28.0003H8.0013C6.52854 28.0003 5.33464 26.8064 5.33464 25.3337V23.3337Z"
                          fill="#737373"
                        />
                      </svg>
                      <p className="upload-placeholder-text">
                        Upload a file <span>or drag and drop</span>
                      </p>
                      <p className="upload-image-requirement">
                        PNG, JPG, GIF up to 5MB
                      </p>
                    </>
                  )}
                </div>
              </div>

              {/* <div>
                <div className="btn-upload">
                  <input
                    type="file"
                    id="judge-doc"
                    accept=".pdf, .doc, .docx, .xls, .xlsx, .txt, image/*"
                    onChange={onAppenDocument}
                  />
                  <label htmlFor={`judge-doc`}>
                    Front Load Judge's Note: {noteFile?.filename}
                  </label>
                </div>
              </div> */}
              <div
                className="hearing-button-group"
                style={{
                  justifyContent: "flex-end",
                  marginTop: 24,
                  marginBottom: 24,
                }}
              >
                <JisButton onClick={onSaveNote}>Save Judge note</JisButton>{" "}
                 {/* <div style={{ display: "flex", alignItems: "center", gap: "12px", marginTop: "10px" }}>
        <JisVoiceRecorder
        transcribeUrl={stribeurl} 
        token={token} 
        onTranscriptionComplete={handleNewTranscriptionText} 
        onStatusChange={onStatusChange}
      /> {!isListening && (
        <JisButton variant="outline" onClick={onSaveNote} style={{ marginLeft: "10px" }}>
          Save Record Note
        </JisButton>
      )}
      </div> */}
              </div>
              {judgeNotes?.length > 0 && (
                <div className="table">
                  <div class="table-header">
                    <span>Judge Notes</span>
                  </div>
                  <div className="table-wrapper">
                    <table className="case-details-table">
                      <thead>
                        <tr>
                          <th className="col-title">Note</th>
                          <th>doc</th>
                          <th>Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        {judgeNotes?.map((opt, index) => (
                          <tr key={opt.id}>
                            <td> {opt.note || "N/A"}</td>
                            <td>
                              {opt.uploadDoc != null ? (
                                <JisButton
                                  variant="plain"
                                  onClick={() => previewDocument(opt.uploadDoc)}
                                >
                                  View Document
                                </JisButton>
                              ) : (
                                "N/A"
                              )}
                            </td>
                            <td>
                              {opt.createdOn
                                ? Constants.momentDate(opt.createdOn)?.format(
                                    "DD MMM, YYYY",
                                  )
                                : "N/A"}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
        {tab == "recorder" && (
          <div className="tab_view">
            <div>
              {/* <h3>Court Recorder Note:</h3>
              <hr /> */}
              <div className="input-group judge-note-input-wrapper">
                <label htmlFor="judge-recorder">Court Recorder’s Note</label>

                <div className="input-wrapper">
                  <textarea
                    
                    placeholder={ "Listening..."}
                    required={true}
                    value={recorderText}
                    style={{ height: 300 }}
                    readOnly
                    onChange={(e) => setRecorderText(e.target.value)}
                  />
                </div>
              </div>
             
            </div>
          </div>
        )}
        {tab == "ruling" && (
          <div className="view">
            {!isMotionPending && (
              <div
                className="hearing-button-group"
                style={{
                  justifyContent: "flex-end",
                  marginBottom: 24,
                }}
              >
                <JisButton onClick={onMainCaseRuling}>
                  {eventType?.toUpperCase()} Pronoucement/Judgement
                </JisButton>
              </div>
            )}
          
          <ViewJudgement 
          caseId={cinfo?.caseinfo?.caseId}
           caseinfo={cinfo.caseinfo}
              parties={cinfo.parties}
              claims={cinfo.claims}
              motions={cinfo.motions} />

         

          </div>
        )}
        {tab == "casecomments" && cinfo?.caseinfo?.caseId && (
          <div className="tab_view">
            <ViewComments
              caseId={cinfo?.caseinfo?.caseId}
              comments={cinfo?.comments}
              isAction={false}
            />
          </div>
        )}

        {tab == "casedocuments" && cinfo?.caseinfo?.caseId && (
          <div className="tab_view">
            <ViewDocuments
              caseId={cinfo?.caseinfo?.caseId}
              documents={cinfo?.documents}
              isAction={false}
            />
          </div>
        )}
      </div>

      {openRuling && (
        <JisDialogForm
          title="Ruling/Order"
          onClose={() => setOpenRuling(false)}
        >
          <div className="ruling-order-modal">
         
            <div>
              <div className="input-group">
                <label htmlFor="motionReport">Motion Report</label>
                <div className="input-wrapper">
                  <textarea
                    id="motionReport"
                    placeholder=""
                    required={true}
                    value={motionNote}
                    // style={{ height: 200 }}
                    onChange={(e) => setMotionNote(e.target.value)}
                  />
                </div>
              </div>
              <div className="file-upload-wrapper">
                <div className="btn-upload">
                  <input
                    type="file"
                    id="judge-doc"
                    accept=".pdf, .doc, .docx, .xls, .xlsx, .txt, image/*"
                    onChange={onAppendMotionDocument}
                  />
                  <label htmlFor={`judge-doc`}>
                    Front Load Motion Report/Order {docFile?.filename}
                  </label>
                </div>
                {docFile?.path && (
                  <button
                    type="button"
                    className="btn-preview"
                    onClick={() => openPreview(docFile.path)}
                  >
                    Preview Document
                  </button>
                )}
              </div>
              <div>
                <div className="select-group">
                  <label>
                    {" "}
                    Ruling <span className="required">*</span>{" "}
                  </label>
                  <select
                    name="orderTypeId"
                    value={orderTypeId}
                    required={true}
                    onChange={(e) => setOrdertypeId(e.target.value)}
                  >
                    <option value="">Select </option>
                    {orderTypes
                      .filter(
                        (e) => e.eventType == "Motion" || e.eventType == "All",
                      )
                      .map(
                        (opt) =>
                          (cinfo?.motions[motionIndex].motionTypeId == 10 || cinfo?.motions[motionIndex].motionTypeId == 24) &&
                          opt.title?.toLowerCase().includes("vacation") && (
                            <option key={opt.value} value={opt.id}>
                              {opt.title}
                            </option>
                          ),
                      )}

                    {orderTypes
                      .filter(
                        (e) => e.eventType == "Motion" || e.eventType == "All",
                      )
                      .map(
                        (opt) =>
                          opt.title?.toLowerCase().includes("grant") && (
                            <option key={opt.value} value={opt.id}>
                              {opt.title}
                            </option>
                          ),
                      )}
                  </select>
                </div>
              </div>
              <div className="calendar-button-group">
                <JisButton
                  onClick={() => setOpenRuling(false)}
                  type="button"
                  variant="outline"
                >
                  Cancel
                </JisButton>
                <JisButton onClick={onDeposeMotion}>Dipose Ruling</JisButton>
              </div>
            </div>
            <div></div>
          </div>
        </JisDialogForm>
      )}

      {openJudgement && (
        <JisDialogForm
          // title={`${eventType?.toUpperCase()} Hearing`}
          title={isDirectStruckOut ? "Struck Out" : "Judgement"}
          onClose={() => {
            setOpenJudgement(false);
            setHearingStatus("");
          }}
        >
          <div className="case-judgement-modal">
            {/* <div>
              <div className="label-value">
                <div className="label">Suit Number</div>
                <div className="value">{cinfo?.caseinfo?.caseNumber}</div>
              </div>
              <div className="label-value">
                <div className="label">Parties to the Case</div>
                <div className="value">{cinfo?.caseinfo?.caseTitle}</div>
              </div>
              <div className="label-value">
                <div className="label"></div>
                <div className="value"></div>
              </div>
            </div>
            <hr /> */}
            <form onSubmit={onMainDeposeJudgement}>
              <div>
                {/* <h3>{eventType?.toUpperCase()} Report:</h3>
                <hr /> */}

                {/*  <div>
        <div className="btn-upload">
            <input type="file" id="judge-doc"  accept="image/*" onChange={onAppendMotionDocument} />
            <label  htmlFor={`judge-doc`}>Front Load  Report/Order</label>
        </div></div> */}
                {!isDirectStruckOut && (
                  <div>
                    <div className="select-group">
                      <label> Hearing Status </label>
                      <select
                        name="hearingstatus"
                        value={hearingStatus}
                        required={true}
                        onChange={(e) => setHearingStatus(e.target.value)}
                      >
                        <option selected="selected" value="">
                          Select
                        </option>
                       {/*  <option value="Adjourned">Adjourned</option>
                        <option value="Dismissed">Dismissed</option>
                        <option value="Withdraw">Withdraw</option>
                        <option value="Closed">Closed</option>
                        <option value="FinalJudgement">FinalJudgement</option>
                        <option value="Struck out">Struck out</option> */}
                         {judgementTypes.filter((opt) => (opt.jType === "Hearing Status" || opt.jType === `Hearing Status ${eventType}`)).map((opt) => (
                          <option key={opt.id} value={opt.title}>
                              {opt.title}
                          </option>
                          ))}
                      </select>
                    </div>
                  </div>
                )}
                {hearingStatus == "Closed" && (
                  <div>
                    <JisCheckbox
                      value={isAnotherday}
                      label="(Select if this case is to be Scheduled for another day)"
                      onChange={(e) => setIsAnotherday(e)}
                    />
                    {isAnotherday && (
                      <div>
                        {" "}
                        <div style={{ display: "flex" }}>
                          <div className="input-group">
                            <label>
                              {" "}
                              Schedule Date <span className="required">*</span>
                            </label>
                            <div className="input-wrapper">
                              {/* <DynamicIcon iname="calendar_clock" /> */}
                              <input
                                name="scheduleDate"
                                type="date"
                                required
                                value={adjournSchedule.scheduleDate}
                                onChange={onScheduleChange}
                                placeholder="Date"
                              />
                            </div>
                          </div>
                          <div className="input-group">
                            <label>
                              {" "}
                              Start Time<span className="required">*</span>
                            </label>
                            <div className="input-wrapper">
                              {/* <DynamicIcon iname="acute" /> */}
                              <input
                                placeholder="Start Time"
                                type="time"
                                name="startTime"
                                required={true}
                                value={adjournSchedule.startTime}
                                onChange={onScheduleChange}
                              />
                            </div>
                          </div>
                          <div className="input-group">
                            <label>
                              {" "}
                              End Time<span className="required">*</span>
                            </label>
                            <div className="input-wrapper">
                              {/* <DynamicIcon iname="chronic" /> */}
                              <input
                                placeholder="Time"
                                type="time"
                                required={true}
                                name="endTime"
                                value={adjournSchedule.endTime}
                                onChange={onScheduleChange}
                              />
                            </div>
                          </div>
                        </div>
                        {/* <div  className="input-group">
                                <label> Agenda</label>
                                <div className='input-wrapper'>
                                    <textarea required={true} name="agenda" placeholder='Agenda...' value={adjournSchedule.agenda}  onChange={onScheduleChange}></textarea>
                                </div>
                            </div> */}
                      </div>
                    )}
                  </div> 
                )}

                <div className="input-group">
                  <label htmlFor="hearingReport">
                    {/* {eventType?.toUpperCase()} Report: */}
                    Comment {hearingStatus}
                  </label>
                  <div className="input-wrapper">
                    <textarea
                      id="hearingReport"
                      placeholder="Add Comment"
                      required={true}
                      value={hearingNote}
                      onChange={(e) => setHearingNote(e.target.value)}
                    />
                  </div>
                </div>
                {(hearingStatus == "Struck out" || hearingStatus == "Not Settled") && (
                  <div className="file-upload-wrapper">
                    <div className="btn-upload">
                      <input
                        type="file"
                        id="struckout-doc"
                        accept=".pdf, .doc, .docx, .xls, .xlsx, .txt, image/*"
                        onChange={onAppendMotionDocument}
                        required
                      />
                      <label htmlFor="struckout-doc">
                       {hearingStatus == "Struck out" && <span>Upload Struck Out Report: {docFile?.filename}</span>} 
                       {hearingStatus == "Not Settled" && <span>Upload Not Settled Report: {docFile?.filename}</span>} 
                      </label>
                    </div>
                    {docFile?.path && (
                      <button
                        type="button"
                        className="btn-preview"
                        onClick={() => openPreview(docFile.path)}
                      >
                        Preview Document
                      </button>
                    )}
                  </div>
                )}
                <div className="calendar-button-group">
                  <JisButton
                    onClick={() => {
                      setOpenJudgement(false);
                      setHearingStatus("");
                    }}
                    type="button"
                    variant="outline"
                  >
                    Cancel{" "}
                  </JisButton>
                  <JisButton type="submit">Dispose Case </JisButton>
                </div>
              </div>
            </form>
            <div></div>
          </div>
        </JisDialogForm>
      )}
      {isContinue && (
        <JisPrompt
          open={isContinue}
          title={actionType == "motion" ? "Ruling" : "Judgement/Pronouncement"}
          onOk={onContinueRuling}
          onCancel={onCancelRuling}
        >
          <div>
            <strong>
              Are you sure you want to proceed with this{" "}
              {actionType == "motion" ? "Ruling" : "Judgement/Pronouncement"}?
            </strong>
          </div>
        </JisPrompt>
      )}

      {isMotionRuling && (
        <JisDialogForm
          title="Order Ruling"
          onClose={() => setIsMotionRuling(false)}
        >
          <div>
            <div>
              <div className="label-value">
                <div className="label">Suit Number</div>
                <div className="value">{cinfo?.caseinfo?.caseNumber}</div>
              </div>
              <div className="label-value">
                <div className="label">Parties to the Case</div>
                <div className="value">{cinfo?.caseinfo?.caseTitle}</div>
              </div>
              <div className="label-value">
                <div className="label"></div>
                <div className="value"></div>
              </div>
            </div>
            <hr />
            <div>
              <h4>Selected Prayers</h4>
              {motionIndex >= 0 && (
                <div>
                  {cinfo?.motions[motionIndex].prayers
                    ?.filter((e) => e.selected)
                    .map((pray, index) => (
                      <div key={pray.id} className="selected">
                        {" "}
                        {pray.prayer}
                      </div>
                    ))}
                </div>
              )}
            </div>
            <hr />
            <div style={{ display: "flex" }}>
              <div style={{ flex: 1 }}>
                <h4>Order in favour of</h4>
                <div>
                  {cinfo?.parties?.map((party, index) => (
                    <div
                      key={party.id}
                      className={`selected ${
                        partiesInfavour.has(party.id) ? "active" : ""
                      }`}
                      onClick={() => onFavourPick(party)}
                    >
                      {" "}
                      {party.firstName} {party.lastName ?? ""}
                    </div>
                  ))}
                </div>
              </div>
              <div style={{ flex: 1 }}>
                <div className="input-group">
                  <label>Motion Summary</label>
                  <div className="input-wrapper">
                    <textarea
                      placeholder=""
                      required={true}
                      value={motionSummary}
                      style={{ height: 200 }}
                      onChange={(e) => setMotionSummary(e.target.value)}
                    />
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div className="select-group">
              <label>
                {" "}
                Pronouncement <span className="required">*</span>{" "}
              </label>
              <select
                name="pronounceId"
                value={pronounceId}
                required={true}
                onChange={(e) => setPronunceId(e.target.value)}
              >
                <option value="">Select </option>
                {pronouncementTypes
                  .filter((e) => e.type == "Motion" || e.eventType == "All")
                  .map((opt) => (
                    <option key={opt.value} value={opt.id}>
                      {opt.title}
                    </option>
                  ))}
              </select>
            </div>
            <hr />
            <div>
              <div className="file-upload-wrapper">
                <div className="btn-upload">
                  <input
                    type="file"
                    id="judge-doc"
                    accept=".pdf, .doc, .docx, .xls, .xlsx, .txt, image/*"
                    onChange={onAppendMotionDocument}
                  />
                  <label htmlFor={`judge-doc`}>
                    Front Load Motion Report/Order {docFile?.filename}
                  </label>
                </div>
                {docFile?.path && (
                  <button
                    type="button"
                    className="btn-preview"
                    onClick={() => openPreview(docFile.path)}
                  >
                    Preview Document
                  </button>
                )}
              </div>
            </div>
            <hr />
            <div>
              <JisButton onClick={onVerdict}>Save Verdict</JisButton>
            </div>
          </div>
        </JisDialogForm>
      )}

      {isAdjourn && (
        <JisDialogForm title="Adjourn Case" onClose={() => setIsAdjourn(false)}>
          <div className="adjournment-modal">
            {/* <h2>Request By</h2> */}
            {/* <div>
              {adjournByList.map((e, index) => (
                <div key={index}>
                  <JisCheckbox
                    label={e}
                    value={selectedAdjournby.has(index)}
                    onChange={(e) => onAdjournByPick(index)}
                  />
                </div>
              ))}
            </div> */}
            <div className="input-group">
              <label>Adjournment Request By: </label>
              <MultiSelectDropdown
                options={adjournByList.map((item, index) => ({
                  id: index,
                  title: item,
                }))}
                onChange={(selectedOptions) => {
                  const newSet = new Set(
                    selectedOptions.map((option) => option.id),
                  );
                  setSelectedAdjournby(newSet);
                }}
              />
            </div>

            <form onSubmit={onSaveAdjournment}>
              {selectedAdjournby.has(3) && (
                <div className="input-group">
                  <label> Other</label>
                  <div className="input-wrapper">
                    <DynamicIcon iname="person_3" />
                    <input
                      label=""
                      placeholder="Adjourn by other"
                      value={otherAdjourn}
                      onChange={(e) => setOtherAdjourn(e.target.value)}
                      required={true}
                    />
                  </div>
                </div>
              )}
              <div>
                <JisYesNo
                  yes="With New Schedule Date"
                  no="Without a schedule date"
                  value={isAdjournSchedule}
                  onChange={(e) => setIsAdjournSchedule(e)}
                />
              </div>
              {isAdjournSchedule && (
                <div>
                  {" "}
                  <div className="date-time-picker">
                    <div className="input-group">
                      <label>
                        {" "}
                        Schedule Date <span className="required">*</span>
                      </label>
                      <div className="input-wrapper">
                        <DynamicIcon iname="calendar_clock" />
                        <input
                          name="scheduleDate"
                          type="date"
                          required
                          value={adjournSchedule.scheduleDate}
                          onChange={onScheduleChange}
                          placeholder="Date"
                        />
                      </div>
                    </div>
                    <div className="input-group">
                      <label>
                        {" "}
                        Start Time<span className="required">*</span>
                      </label>
                      <div className="input-wrapper">
                        <DynamicIcon iname="acute" />
                        <input
                          placeholder="Start Time"
                          type="time"
                          name="startTime"
                          required={true}
                          value={adjournSchedule.startTime}
                          onChange={onScheduleChange}
                        />
                      </div>
                    </div>
                    <div className="input-group">
                      <label>
                        {" "}
                        End Time<span className="required">*</span>
                      </label>
                      <div className="input-wrapper">
                        <DynamicIcon iname="chronic" />
                        <input
                          placeholder="Time"
                          type="time"
                          required={true}
                          name="endTime"
                          value={adjournSchedule.endTime}
                          onChange={onScheduleChange}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="input-group">
                    <label> Agenda</label>
                    <div className="input-wrapper">
                      <textarea
                        required={true}
                        name="agenda"
                        placeholder="Agenda..."
                        value={adjournSchedule.agenda}
                        onChange={onScheduleChange}
                      ></textarea>
                    </div>
                  </div>
                </div>
              )}

              <div className="calendar-button-group">
                <JisButton
                  variant="outline"
                  onClick={() => setIsAdjourn(false)}
                >
                  Cancel
                </JisButton>
                <JisButton type="submit">Schedule New Case </JisButton>
              </div>
            </form>
          </div>
        </JisDialogForm>
      )}

      {isFinal && (
        <JisDialogForm
          minWidth="40%"
          title="Final Judgement"
          onClose={() => setIsFinal(false)}
        >
          <div style={{ minWidth: "90vh" }}>
            <div>
              <div className="label-value">
                <div className="label">Suit Number</div>
                <div className="value">{cinfo?.caseinfo?.caseNumber}</div>
              </div>
              <div className="label-value">
                <div className="label">Parties to the Case</div>
                <div className="value">{cinfo?.caseinfo?.caseTitle}</div>
              </div>
            </div>

            <div>
              <div style={{ flex: 1 }}>
                <h4>{claimType}s with Pronouncement</h4>
                {cinfo?.claims
                  ?.filter((d) => d.rulingId != null)
                  .map((opt, index) => (
                    <div key={opt.id} className="selected-disabled">
                      {opt.claim}
                      <div>
                        <span>{opt.currencyType}</span>
                        <span>{Constants.formatCurrency(opt.claimValue)}</span>
                        <span>{opt.type}</span>
                      </div>
                    </div>
                  ))}

                {cinfo?.claims?.filter((d) => d.rulingId != null).length ==
                  0 && <JisEmptyList />}
              </div>
              <div style={{ flex: 1 }}>
                <h4>{claimType}s awaiting Pronouncement</h4>
                {cinfo?.claims
                  ?.filter((d) => d.rulingId == null)
                  .map((opt, index) => (
                    <div
                      key={opt.id}
                      className={`selected ${
                        selectedClaim != null && selectedClaim.id == opt.id
                          ? "active"
                          : ""
                      }`}
                      onClick={() => setSelectedClaim(opt)}
                    >
                      {opt.claim}
                      {claimType == "Claim" && (
                        <div>
                          <span>{opt.currencyType}</span>
                          <span>
                            {Constants.formatCurrency(opt.claimValue)}
                          </span>
                          <span>{opt.type}</span>
                        </div>
                      )}
                    </div>
                  ))}
                {cinfo?.claims?.filter((d) => d.rulingId == null).length ==
                  0 && <JisEmptyList />}
              </div>
            </div>
            <hr></hr>
            <div>
              <h3>Current {claimType}</h3>
              <div className="selected-disabled">{selectedClaim?.claim}</div>
            </div>
            <hr />

            <form onSubmit={onJudgement}>
              <div style={{ display: "flex" }}>
                <div style={{ flex: 1 }}>
                  <h4>
                    Pronouncement{" "}
                    {judgementOptions.isFavour
                      ? "in favour of"
                      : "Against"}{" "}
                  </h4>
                  <div>
                    {cinfo?.parties?.map((party, index) => (
                      <div
                        key={party.id}
                        className={`selected ${
                          partiesInfavour.has(party.id) ? "active" : ""
                        }`}
                        onClick={() => onFavourPick(party)}
                      >
                        {" "}
                        {party.firstName} {party.lastName ?? ""}
                      </div>
                    ))}
                  </div>
                </div>
                <div style={{ flex: 1 }}>
                  <div className="select-group">
                    <label>
                      {" "}
                      Pronouncement <span className="required">*</span>{" "}
                    </label>
                    <select
                      name="pronouncedId"
                      value={judgement.pronouncedId}
                      required={true}
                      onChange={onJudgementChange}
                    >
                      <option value="">Select </option>
                      {pronouncementTypes
                        .filter(
                          (e) => e.type == "Judgement" || e.eventType == "All",
                        )
                        .map((opt) => (
                          <option key={opt.value} value={opt.id}>
                            {opt.title}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>
              </div>

              <div className="input-group">
                <label>Judgement Summary</label>
                <div className="input-wrapper">
                  <textarea
                    placeholder=""
                    required={true}
                    name="summary"
                    value={judgement.summary}
                    style={{ height: 150 }}
                    onChange={onJudgementChange}
                  />
                </div>
              </div>
              <hr />
              <div style={{ display: "flex" }}>
                <JisCheckbox
                  value={judgementOptions.isAmount}
                  label="Check if amount is granted"
                  onChange={(e) =>
                    setJudgementOption({ ...judgementOptions, isAmount: e })
                  }
                />
                {judgementOptions.isAmount && (
                  <JisCheckbox
                    value={judgementOptions.isInterest}
                    label="Check if amount requies Interest"
                    onChange={(e) =>
                      setJudgementOption({ ...judgementOptions, isInterest: e })
                    }
                  />
                )}
                <JisCheckbox
                  value={judgementOptions.isSentence}
                  label="Check if sentence is involve"
                  onChange={(e) =>
                    setJudgementOption({ ...judgementOptions, isSentence: e })
                  }
                />
              </div>
              <hr />
              {judgementOptions.isSentence && (
                <div style={{ display: "flex" }}>
                  <div className="select-group">
                    <label>
                      {" "}
                      Sentence Duration Type{" "}
                      <span className="required">*</span>{" "}
                    </label>
                    <select
                      name="SentenceDurationType"
                      value={judgement.SentenceDurationType}
                      required={true}
                      onChange={onJudgementChange}
                    >
                      <option value="">Select </option>
                      <option value="year">Year</option>
                      <option value="monthly">Month</option>
                    </select>
                  </div>
                  <div className="input-group">
                    <label> Sentence Duration</label>
                    <div className="input-wrapper">
                      <DynamicIcon iname="person_3" />
                      <input
                        placeholder="Duration"
                        name="SentenceDuration"
                        value={judgement.SentenceDuration}
                        onChange={onJudgementChange}
                        required={true}
                        type="number"
                      />
                    </div>
                  </div>
                </div>
              )}
              <hr></hr>
              <div>
                {judgementOptions.isAmount && (
                  <div style={{ display: "flex" }}>
                    <div className="select-group">
                      <label>
                        {" "}
                        Currency <span className="required">*</span>{" "}
                      </label>
                      <select
                        name="currency"
                        value={judgement.currency}
                        required={true}
                        onChange={onJudgementChange}
                      >
                        <option value="">Select</option>
                        <option value="N">Naira</option>
                        <option value="$">Dollar</option>
                        <option value="e">Euro</option>
                      </select>
                    </div>
                    <div className="input-group">
                      <label> Amount Granted</label>
                      <div className="input-wrapper">
                        <DynamicIcon iname="person_3" />
                        <input
                          placeholder=" Amount Granted"
                          name="amountGranted"
                          value={Constants.formatCurrency(
                            judgement.amountGranted,
                          )}
                          onChange={onJudgementChange}
                          required={true}
                        />
                      </div>
                    </div>
                    {/* <div  className="input-group">
                  <label> Cost awarded</label>
                  <div className='input-wrapper'>
                      <DynamicIcon iname="person_3" />
                    <input
                      placeholder='Cost awarded'
                      name="costAwarded"
                      value={judgement.costAwarded}
                      onChange={onJudgementChange}
                      required={true}
                    />
                  </div>
              </div> */}
                  </div>
                )}

                <hr />
                {judgementOptions.isAmount && judgementOptions.isInterest && (
                  <div>
                    <h4>Interest</h4>
                    <div style={{ display: "flex" }}>
                      <div className="select-group">
                        <label>
                          {" "}
                          Interest Type <span className="required">*</span>{" "}
                        </label>
                        <select
                          name="interestType"
                          value={judgement.interestType}
                          required={true}
                          onChange={onJudgementChange}
                        >
                          <option value="">Select </option>
                          <option value="simple">Simple</option>
                          <option value="compound">Compound</option>
                        </select>
                      </div>
                      <div className="input-group">
                        <label> Rate Percentage</label>
                        <div className="input-wrapper">
                          <DynamicIcon iname="person_3" />
                          <input
                            placeholder="Rate"
                            name="rate"
                            value={judgement.rate}
                            onChange={onJudgementChange}
                            required={true}
                          />
                        </div>
                      </div>
                      <div className="input-group">
                        <label>From (To calculate from)</label>
                        <div className="input-wrapper">
                          <DynamicIcon iname="person_3" />
                          <input
                            placeholder="From Year"
                            name="fromYear"
                            max={moment()}
                            value={judgement.fromYear}
                            onChange={onJudgementChange}
                            required={true}
                            type="date"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                <hr />
                {judgementOptions.isAmount && (
                  <div style={{ textAlign: "center" }}>
                    <h2 style={{ textAlign: "center" }}>
                      {judgement.currency}{" "}
                      {Constants.formatCurrency(totalAmount)}
                    </h2>
                    <span> Amount</span>
                  </div>
                )}
                <div style={{ textAlign: "center" }}>
                  <JisButton type="submit">Add Judgement</JisButton>
                </div>
              </div>
            </form>

            <div className="table">
              <div class="section-cases">
                <span>Judgement(s)</span>
                <span className="total">
                  {hearingData?.claimruling?.length}
                </span>
              </div>
              <table class="case-table">
                <thead>
                  <tr>
                    <th className="col-title">Claim/Offence</th>
                    <th className="col-title">Pronouncement</th>
                    <th>Favour</th>
                    <th className="col-medium">Date Pronounced</th>
                    <th className="col-title">Other Details</th>
                  </tr>
                </thead>
                <tbody>
                  {hearingData?.claimruling?.map((opt, index) => (
                    <tr>
                      <td>
                        {cinfo?.claims.find((d) => d.rulingId == opt.id)?.claim}
                      </td>
                      <td>
                        {
                          pronouncementTypes?.find(
                            (d) => d.id == opt.pronounceTypeId,
                          )?.title
                        }
                      </td>
                      <td>
                        In favour of
                        {hearingData?.claimfavour
                          ?.filter((e) => e.claimRulingId == opt.id)
                          .map((favour, index) => {
                            const p = cinfo?.parties?.find(
                              (d) => d.id === favour.partyId,
                            );
                            return (
                              <div
                                key={favour.id}
                                className="selected-disabled"
                              >
                                {p?.firstName} {p?.lastName ?? ""}
                              </div>
                            );
                          })}
                      </td>
                      <td>{Constants.displayDate(opt.orderGivenOn)}</td>
                      <td>
                        {opt.grantedAmount != null && (
                          <div className="selected-disabled">
                            <div className="label-value">
                              <span className="label">Amount Granted</span>
                              <span className="value">
                                {Constants.formatCurrency(opt.grantedAmount)}
                              </span>
                            </div>
                          </div>
                        )}
                        {opt.interestType != "" && (
                          <div className="selected-disabled">
                            <div className="label-value">
                              <span className="label">Interest</span>
                              <span className="value">{opt.interestType}</span>
                            </div>
                          </div>
                        )}
                        {opt.rate != null && (
                          <div className="selected-disabled">
                            <div className="label-value">
                              <span className="label">Rate</span>
                              <span className="value">{opt.rate}%</span>
                            </div>
                          </div>
                        )}
                        {opt.interestFrom != null && (
                          <div className="selected-disabled">
                            <div className="label-value">
                              <span className="label">Interest From</span>
                              <span className="value">{opt.interestFrom}</span>
                            </div>
                          </div>
                        )}
                        {opt.sentenceDurationType != null && (
                          <div className="selected-disabled">
                            <div className="label-value">
                              <span className="label">Judgment</span>
                              <span className="value">
                                {opt.sentenceDuration}
                                {opt.sentenceDurationType}(s)
                              </span>
                            </div>
                          </div>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div style={{ display: "flex" }}>
              <div className="input-group">
                <label> Number of Witness(es) {hearingId}</label>
                <div className="input-wrapper">
                  <DynamicIcon iname="person_3" />
                  <input
                    placeholder="Number of Witness"
                    name="witness"
                    value={judgement.witness}
                    onChange={onJudgementChange}
                    required={true}
                  />
                </div>
              </div>
              <JisCheckbox
                label="Please check if this case Contested?"
                value={judgement.isContested}
                onChange={(e) => setJudgement({ ...judgement, isContested: e })}
              />
            </div>
            <div>
              {/* <div className="select-group">
          <label> Judgement Type <span className="required">*</span> </label>
          <select name="judgementTypeId" value={judgement.judgementTypeId} onChange={onJudgementChange}   >
              <option value="">Select </option>
              {judgementTypes.map((opt) => (
              <option key={opt.value} value={opt.id}>
                  {opt.title}
              </option>
              ))}
          </select>
          </div> */}
              <div className="select-group">
                <label>
                  {" "}
                  Type of Conclusion: <span className="required">*</span>{" "}
                </label>
                <select
                  name="judgementType"
                  value={judgement.judgementType}
                  onChange={onJudgementChange}
                >
                  <option value="">Select</option>
                 {/*  
                  <option value="Judgement">Judgement</option>
                  <option value="Settlement">Settlement</option>
                  <option value="Sentence">Sentence</option>
                  <option value="StruckOut">StruckOut</option> */}
                   {judgementTypes.filter((opt) => opt.jType === "Conclusion").map((opt) => (
                          <option key={opt.id} value={opt.title}>
                              {opt.title}
                          </option>
                          ))}
                </select>
              </div>
            </div>

            <div style={{ marginBottom: 16, marginTop: 16 }}>
              <div className="file-upload-wrapper">
                <div className="btn-upload">
                  <input
                    type="file"
                    id="judge-doc"
                    accept=".pdf, .doc, .docx, .xls, .xlsx, .txt, image/*"
                    onChange={onAppendFinalDocument}
                  />
                  <label htmlFor={`judge-doc`}>
                    Judgment Front Load Documents: {finalDocFile?.filename}
                  </label>
                </div>
                {finalDocFile?.path && (
                  <button
                    type="button"
                    className="btn-preview"
                    onClick={() => openPreview(finalDocFile.path)}
                  >
                    Preview Document
                  </button>
                )}
              </div>
            </div>
            {cinfo?.claims?.filter((d) => d.rulingId == null).length == 0 && (
              <div style={{ textAlign: "center" }}>
                <JisButton onClick={onFinalJudgement}>
                  Submit Final Judgement
                </JisButton>
              </div>
            )}
            {/* {cinfo?.claims?.filter((d) => d.rulingId == null).length == 0 && (
              //pending fixing
            )} */}
          </div>
        </JisDialogForm>
      )}
      {openCase && (
        <JisDialogForm title="Case Details" onClose={onCloseOpenCase}>
          <div>
            <CaseDetails
              caseId={cinfo?.caseinfo?.caseId}
              data={null}
              token={token}
              initialtab="casedocuments"
            />
          </div>
        </JisDialogForm>
      )}
      {openAdopt && (
        <JisDialogForm title="Case Judgement" onClose={onCloseOpenAdopt}>
          <form onSubmit={onSaveAdr}>
            {clearType == "adoption" && (
              <>
                <div style={{ fontSize: 24 }}>The Settlement Adopted</div>
              </>
            )}

            {clearType == "struckout" && (
              <>
                <div style={{ fontSize: 24 }}>This case will be struck-out</div>
              </>
            )}

            <div className="input-group">
              <label>
                {" "}
                Comment<span className="required">*</span>{" "}
              </label>
              <div className="input-wrapper">
                <DynamicIcon iname="group" />
                <textarea
                  placeholder="comment"
                  required={true}
                  value={comment}
                  onChange={(e) => setComment(e.target.value)}
                />
              </div>
            </div>
            <JisButton type="submit">Save </JisButton>
          </form>
        </JisDialogForm>
      )}
      {openNoteModal && (
        <div className="modal-warning">
          <div className="warning-container">
            <h3>Warning</h3>
            <div>
              <p>Please enter Judge's note and save to contiune.</p>
              <button
                onClick={() => {
                  setOpenNoteModal(false);
                  setTab("judgenote");
                }}
                className="warning-btn"
              >
                ok
              </button>
            </div>
          </div>
        </div>
      )}

      <BackLoader open={loading} />

      {openDocumentPreview && (
        <JisDialogForm
          title="Document Preview"
          onClose={() => setOpenDocumentPreview(false)}
        >
          <div style={{ height: "90vh" }}>
            <PdfViewer pdfUrl={previewUrl} />
          </div>
        </JisDialogForm>
      )}
    </div>
  );
}

export default Hearing;
